import React, { useContext, useState } from 'react';
import _ from 'lodash';
import TieredPricingListItem from './TieredPricingListItem.jsx';
import AuthenticateModal from '../../HomeDeliveryNew/AuthenticateModal/index.js';
import DrugPageBanner from './DrugPageBanner.jsx';
import LoyaltyPricingBanner from '../LoyalyPricingBanner.js';
import { BONUS_PRICE } from '../../../constants/defaults.js';
import { AuthContext } from '../../../Contexts.js';

// const { API } = require('../../../config/' + process.env.REACT_APP_ENV);

//let initialDrugPageLoad = false;

const TieredPricingList = props => {
  const {
    doNotMarket = false,
    drugData = {},
    drugName = '',
    userPoints = 0,
    tieredPricingData = {},
    drugInformationOverrideSeoName = ''
  } = props;
  const {
    PharmacyPricings,
    lowestPrice,
    lowestPricePharmacyName,
    isLoyaltyApplicable
  } = tieredPricingData;
  const [isOpenSignupModal, setIsOpenSignupModal] = useState(false);
  const [expandedCoupon, setExpandedCoupon] = useState(1);
  const context = useContext(AuthContext);

  const renderPharmacyList = (
    drugName,
    pharmacyPricing,
    drugData,
    lowestPrice,
    lowestPricePharmacyName,
    doNotMarket,
    maxPharmacyPosition
  ) => {
    //if coupouns is active then dont show genius rx
    //if home delievery is active show genius rx item
    if (!_.isEmpty(pharmacyPricing)) {
      return pharmacyPricing.map((item, id) => {
        return (
          <>
            <TieredPricingListItem
              key={id}
              item={item}
              drugName={drugName}
              drugData={drugData}
              position={id + 1}
              selectedDisplayQuantity={props.selectedDisplayQuantity}
              handlepFizer={props.handlepFizer}
              isProceedClicked={props.isProceedClicked}
              doNotMarket={doNotMarket}
              userPoints={userPoints}
              lowestPrice={lowestPrice}
              lowestPricePharmacyName={lowestPricePharmacyName}
              maxPharmacyPosition={maxPharmacyPosition}
              geniusRxPrice={props.geniusRxPrice}
              isMobileDevice={props.isMobileDevice}
              isPricingUpdated={props.isPricingUpdated}
              setIsPricingUpdated={props.setIsPricingUpdated}
              customQuantity={props.customQuantity}
              drugInformationOverrideSeoName={drugInformationOverrideSeoName}
              expandedCoupon={expandedCoupon}
              setExpandedCoupon={setExpandedCoupon}
            />
            {isLoyaltyApplicable &&
              (pharmacyPricing.length === 1 || id === 1) && (
                <LoyaltyPricingBanner />
              )}
          </>
        );
      });
    }
  };

  return (
    <div className="bgLightchocolate">
      {isOpenSignupModal && (
        <div className="mainModal afterSignupmodal">
          <div
            className="transparentBg"
            onClick={() => setIsOpenSignupModal(false)}
          ></div>
          <div className="signUpModal">
            <AuthenticateModal
              hideAuthenticateModal={() => setIsOpenSignupModal(false)}
            />
          </div>
        </div>
      )}
      <div
        id="price-results"
        className="price-results prices-dynamic fiveOffBody"
      >
        <div id="scBannerAbovePricingList"></div>
        {context?.userData?.isLoggedIn ? (
          <>
            <div
              className="pricingBanner themeFocus"
              tabIndex="0"
              onClick={() => setIsOpenSignupModal(true)}
            >
              <img
                src="/content/images/icons/priceTagGreen.svg"
                className="priceTagImage desktop-only"
                alt=""
                height="32"
                width="32"
              />
              <p className="bannerText">
                Unlock an extra <span>${BONUS_PRICE} off</span> &amp; more
                member perks.
              </p>
              <span className="signUpButton">Sign up, it’s free</span>
            </div>
            {isLoyaltyApplicable && (
              <DrugPageBanner
                openSignupModal={() => setIsOpenSignupModal(true)}
              />
            )}
          </>
        ) : (
          <div className="pricingBanner signUpText">
            <img
              src="/content/images/icons/priceTagGreen.svg"
              className="priceTagImage desktop-only"
              alt=""
              height="24"
              width="24"
            />
            <p className="bannerText">
              You have{' '}
              <span>
                {userPoints > 1.0 ? (
                  <span>
                    <b>$</b>
                    {Number(userPoints).toFixed(2)}
                  </span>
                ) : (
                  '0.00'
                )}
              </span>{' '}
              in available bonus savings. Bonus savings will be automatically
              applied to your next eligible prescription fill.
            </p>
          </div>
        )}
        <div id="loc-list" className={`loc-list`}>
          {renderPharmacyList(
            drugName,
            PharmacyPricings,
            drugData,
            lowestPrice,
            lowestPricePharmacyName,
            doNotMarket,
            PharmacyPricings && PharmacyPricings.length
          )}
        </div>
      </div>
    </div>
  );
};

export default TieredPricingList;
